import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Store } from '@ngrx/store';

//@todo move this service into this component
import { ProductsService } from '@boma/administration-portal/shared/services';
import {
  addProductImage,
  addProductImageSuccess,
} from '../../../../administration-portal/products/src/lib/+state/products/products.actions';

@Component({
  selector: 'product-image-upload',
  templateUrl: './product-image-upload.component.html',
  styleUrls: ['./product-image-upload.component.scss'],
})
export class ProductImageUploadComponent implements OnInit {
  imageId: string = '';

  constructor(
    public store: Store,
    public sanitizer: DomSanitizer,
    private productService: ProductsService
  ) {}

  ngOnInit(): void {}

  upload(event, form) {
    for (let file of event.files) {
      //console.log(file);

      this.productService.uploadProductImage(file).subscribe((id) => {
        this.imageId = id;
        this.store.dispatch(
          addProductImageSuccess({ imageId: id, file: file })
        );
      });
    }
    form.clear();
  }
}
